document.addEventListener('DOMContentLoaded', function () {

  // — Overlay
  var modalOverlay = document.createElement('div');
  modalOverlay.id = 'MudraApplyModal';
  modalOverlay.setAttribute('aria-hidden', 'true');
  modalOverlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:99999',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'background:rgba(0,0,0,0.7)',
    'padding:16px',
    'box-sizing:border-box'
  ].join(';');

  // — Modal box
  var modalBox = document.createElement('div');
  modalBox.style.cssText = [
    'position:relative',
    'width:100%',
    'max-width:700px',
    'height:90vh',
    'max-height:90vh',
    'background:#fff',
    'border-radius:12px',
    'overflow:hidden',
    'box-shadow:0 20px 60px rgba(0,0,0,0.3)',
    'display:flex',
    'flex-direction:column'
  ].join(';');

  // — Close button
  var closeBtn = document.createElement('button');
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.style.cssText = [
    'position:absolute',
    'top:12px',
    'right:12px',
    'z-index:10',
    'background:rgba(0,0,0,0.6)',
    'border:none',
    'cursor:pointer',
    'color:#fff',
    'border-radius:50%',
    'width:32px',
    'height:32px',
    'font-size:18px',
    'line-height:1',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'flex-shrink:0'
  ].join(';');
  closeBtn.innerHTML = '&times;';

  // — Iframe
  var iframe = document.createElement('iframe');
  iframe.src = 'https://www.mudra-studio.com/embed/register';
  iframe.width = '100%';
  iframe.style.cssText = 'border:0;display:block;width:100%;height:100%;flex:1 1 auto;min-height:0;';
  iframe.setAttribute('loading', 'lazy');
  iframe.setAttribute('title', 'Apply for Mudra Studio');

  modalBox.appendChild(closeBtn);
  modalBox.appendChild(iframe);
  modalOverlay.appendChild(modalBox);
  document.body.appendChild(modalOverlay);

  function openModal() {
    modalOverlay.setAttribute('aria-hidden', 'false');
    modalOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modalOverlay.setAttribute('aria-hidden', 'true');
    modalOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  modalOverlay.style.display = 'none';

  document.querySelectorAll('.open_modal, .prompt-input, .sparkle-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });

  closeBtn.addEventListener('click', closeModal);

  modalOverlay.addEventListener('click', function (e) {
    e.target === modalOverlay && closeModal();
  });

  window.addEventListener('keydown', function (e) {
    e.key === 'Escape' && closeModal();
  });

  window.addEventListener('message', function (e) {
    e.origin === 'https://www.mudra-studio.com' &&
      e.data &&
      e.data.type === 'mudra-registration-success' &&
      closeModal();
  });
});